export const ASPECT_RATIO_PORTRAIT = '10/11';
export const ASPECT_RATIO_LANDSCAPE = '4/3';
